import React, { useState, useEffect, Fragment } from "react";
import {
  Button, Modal, ModalHeader, ModalBody, ModalFooter,
  Input, Label, FormGroup
} from "reactstrap";
import FieldWrapper from "../commons/FieldWrapper";
import DraftInput from "../commons/DraftInput";
import { saveDefaultBenefit } from "./Axios";

const BenefitForm = ({
                       isOpen, onClose,
                       benefit,
                       notify,
                       afterCreate, afterUpdate
                     })=>{
  const [title,setTitle]=useState(benefit?.title||"");
  const [content,setContent]=useState(benefit?.content||""); // HTML
  const [sending,setSending]=useState(false);
  const [errs,setErrs]=useState({title:[],content:[]});

  useEffect(()=>{
    if(isOpen){
      setTitle(benefit?.title||"");
      setContent(benefit?.content||"");
      setErrs({title:[],content:[]});
    }
  },[isOpen,benefit]);

  const save = ()=>{
    setSending(true);
    const fd=new FormData();
    fd.append("default_benefit[title]",title);
    fd.append("default_benefit[content]",content);

    saveDefaultBenefit(benefit,fd,res=>{
      setSending(false);
      if(res.status===201){
        notify("Genial","Beneficio creado","success");
        afterCreate(res.data); onClose();
      }else if(res.status===200){
        notify("Genial","Beneficio actualizado","success");
        afterUpdate(res.data); onClose();
      }else if(res.status===422){
        setErrs(res.data||{}); notify("Ops","Revisa los campos","danger");
      }else notify("Error","Ocurrió un error","danger");
    });
  };

  return(
    <Fragment>
      <Modal isOpen={isOpen} toggle={onClose} size="lg">
        <ModalHeader toggle={onClose}>
          {benefit ? "Editar Beneficio" : "Nuevo Beneficio"}
        </ModalHeader>

        <ModalBody>
          <FormGroup>
            <Label className="input_required" for="bfTitle">Título</Label>
            <FieldWrapper errors={errs.title}>
              <Input id="bfTitle" value={title} onChange={e=>setTitle(e.target.value)} maxLength={120}/>
            </FieldWrapper>
          </FormGroup>

          <FormGroup>
            <Label className="input_required" for="bfContent">Contenido</Label>
            <FieldWrapper errors={errs.content}>
              <DraftInput
                key={benefit ? `b-${benefit.id}` : "new"}
                value={content}
                onChangeInput={setContent}
              />
            </FieldWrapper>
          </FormGroup>
        </ModalBody>

        <ModalFooter>
          <Button color="success" disabled={sending} onClick={save}>
            {sending?"Guardando...":"Guardar"}
          </Button>
          <Button color="secondary" disabled={sending} onClick={onClose}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};
export default BenefitForm;
